import { useTranslation } from "react-i18next";import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '@/shared/contexts/AuthContext';
import { presenceAPI } from '@/shared/services/api';

export const MainLayout = ({ children }) => {const { t } = useTranslation("common");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const { user } = useAuth();
  const connectionId = useRef(
    window.crypto?.randomUUID?.() || `presence-${Date.now()}-${Math.random().toString(16).slice(2)}`
  );

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    const sendHeartbeat = () => {
      if (cancelled || document.visibilityState === 'hidden') return;
      const path = `${location.pathname}${location.search || ''}`;
      const moduleName = location.pathname.split('/').filter(Boolean)[0] || 'dashboard';
      presenceAPI.heartbeat({
        connection_id: connectionId.current,
        page: document.title || moduleName,
        module: moduleName,
        path,
      }).catch(() => {});
    };
    sendHeartbeat();
    const intervalId = window.setInterval(sendHeartbeat, 30000);
    window.addEventListener('focus', sendHeartbeat);
    document.addEventListener('visibilitychange', sendHeartbeat);
    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      window.removeEventListener('focus', sendHeartbeat);
      document.removeEventListener('visibilitychange', sendHeartbeat);
    };
  }, [location.pathname, location.search, user]);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar isCollapsed={isCollapsed} />
      <div className={`transition-all duration-300 ${isCollapsed ? 'ml-16' : 'ml-64'}`}>
        <Header />
        <main className="p-6">{children}</main>
      </div>
    </div>);

};
